import * as Sentry from '@sentry/browser';

export function captureException({error, info = {}}) {
    Sentry.withScope((scope) => {
        Object.entries(info).forEach(([key, val]) => scope.setExtra(key, val));
        Sentry.captureException(error);
    });
}
